export const ROUTES = {
    homepage: '/',
    evacuations: {
        search: '/evacuations',
        view: '/evacuations/:eventId',
    },
    notifications: {
        search: '/notifications',
        test: '/notifications-test',
    },
    checkaccess: '/checkaccess',
    accesspoint: {
        search: '/list-access-points',
        view: '/accesspoint/:accesspointcode',
        permissions: '/accesspoint/:accesspointcode/permissions/:permissionid',
        permits: '/accesspoint/:accesspointcode/permissions/:permissionid/permits',
        request: '/accesspoint/:accesspointcode/permissions/:permissionid/request-access',
    },
    scan: '/scan',
    temporaryBadge: {
        view: '/temporary-badge',
        result: '/functions/temporary-badge/:nonce',
    },
    nfc: '/functions/cern-access',
    favourites: '/favourites',
    accessEmulation: '/functions/access-emulation',
    accessToAccelerators: '/access-to-accelerators',
    validateQr: '/functions/validate-qr',
    visitorCard: '/functions/visitor-card/:nonce',
    myData: '/my-data',
    development: '/development',
    help: '/help/ios/add-to-homescreen',
    anonymous: 'anonymous-visitor',
    notfound: '*',
} as const;
